import { render, staticRenderFns } from "./ArticleSimilarHeadlinesSection.vue?vue&type=template&id=73940a23&scoped=true&"
import script from "./ArticleSimilarHeadlinesSection.vue?vue&type=script&lang=ts&"
export * from "./ArticleSimilarHeadlinesSection.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleSimilarHeadlinesSection.vue?vue&type=style&index=0&id=73940a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73940a23",
  null
  
)

export default component.exports